/**
 * Tokens da identidade visual Manafix (admin).
 * Alinhados a src/index.css e tailwind (primary / laranjinha / monao).
 */
export const MGS = {
  bg: "#111111",
  surface: "#1a1a1a",
  elevated: "#222222",
  text: "#ffedd5",
  muted: "rgba(255, 237, 213, 0.65)",
  primary: "#d59106",
  primaryHover: "#b47c06",
  danger: "#f87171",
  dangerBorder: "#f87171",
};

/** Classes reutilizáveis (Tailwind) */
export const mobileRoot =
  "flex min-h-screen flex-col bg-mgs-bg text-laranjinha";

export const mobileHeader =
  "sticky top-0 z-10 flex items-center gap-2 border-b border-primary bg-mgs-bg px-4 py-3";

export const mobileIconBtn =
  "inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-laranjinha hover:bg-monao";

export const mobileNavActive =
  "bg-primary/20 font-semibold text-primary";

export const mobileNavIdle =
  "text-laranjinha/80 hover:bg-monao hover:text-laranjinha";

export const mobilePrimaryBtn =
  "inline-flex min-h-[44px] items-center justify-center rounded-lg bg-primary px-3 text-sm font-medium text-mgs-bg hover:bg-[#b47c06] disabled:cursor-not-allowed disabled:opacity-50";

export const mobileSecondaryBtn =
  "inline-flex min-h-[44px] items-center justify-center rounded-lg border border-primary/50 px-3 text-sm font-medium text-laranjinha hover:bg-monao disabled:cursor-not-allowed disabled:opacity-50";

export const mobileInput =
  "w-full min-h-[44px] rounded-lg border border-primary/50 bg-monao px-3 text-base text-laranjinha placeholder:text-laranjinha/40 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30";

export const mobileChip =
  "inline-flex min-h-[36px] items-center rounded-full border border-primary/40 bg-primary/15 px-3 text-sm text-laranjinha";

export const mobileChipAccent =
  "inline-flex min-h-[36px] items-center rounded-full bg-primary/20 px-3 text-sm text-primary";
